<template>
    <div class="footer">
        <img src="../../assets/imgs/footer_bg.png" alt="" />
        <ul>
            <li><a href="https://www.hermesgames.com.tw/#/customerCenter?type=companyInfo" target="_blank"></a></li>
            <li><a href="https://www.hermesgames.com.tw/#/customerCenter?type=contactUs" target="_blank"></a></li>
            <li><a href="https://www.hermesgames.com.tw/#/customerCenter?type=serviceTerms" target="_blank"></a></li>
            <li><a href="https://www.hermesgames.com.tw/#/customerCenter?type=privacyPolicy" target="_blank"></a></li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "Footer",
    props: {
        msg: String
    }
};
</script>

<style scoped lang="scss">
.footer {
    width: 100%;
    position: absolute;
    bottom: -1.4rem;
}
.footer ul {
    width: 3.36rem;
    height: 0.5rem;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -2.45rem;
}
.footer ul li {
    width: 0.82rem;
    height: 0.333rem;
    position: absolute;
    cursor: pointer;
    /**background: pink;
    opacity: 0.6;**/
    a{
        display: inline-block;
        width: 100%;
        height: 100%;
    }
    &:nth-child(1) {
        left: 0;
    }
    &:nth-child(2) {
        left: .85rem;
    }
    &:nth-child(3) {
        left: 1.7rem;
    }
    &:nth-child(4) {
        right: 0;
    }
}
</style>
